export default "__VITE_ASSET__DbnQXlJP__"